//  back button 
document.getElementById('backButton').addEventListener('click', function () {
  history.back();
});

//  hide/show password 
document.addEventListener('DOMContentLoaded', function () {
  const passwordInput = document.getElementById('RegisterForm-password');
  const toggleHidePasswordButton = document.getElementById('toggleHidePassword');
  const toggleShowPasswordButton = document.getElementById('toggleShowPassword');

  toggleHidePasswordButton.addEventListener('click', function () {
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
      toggleHidePasswordButton.classList.add('tw-hidden');
      toggleShowPasswordButton.classList.remove('tw-hidden');
    }
  });

  toggleShowPasswordButton.addEventListener('click', function () {
    if (passwordInput.type === 'text') {
      passwordInput.type = 'password';
      toggleShowPasswordButton.classList.add('tw-hidden');
      toggleHidePasswordButton.classList.remove('tw-hidden');
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const passwordConfirmedInput = document.getElementById('password_confirmation');
  const toggleHideConfirmedPasswordButton = document.getElementById('toggleHideConfirmedPassword');
  const toggleShowConfirmedPasswordButton = document.getElementById('toggleShowConfirmedPassword');

  toggleHideConfirmedPasswordButton.addEventListener('click', function () {
    if (passwordConfirmedInput.type === 'password') {
      passwordConfirmedInput.type = 'text';
      toggleHideConfirmedPasswordButton.classList.add('tw-hidden');
      toggleShowConfirmedPasswordButton.classList.remove('tw-hidden');
    }
  });

  toggleShowConfirmedPasswordButton.addEventListener('click', function () {
    if (passwordConfirmedInput.type === 'text') {
      passwordConfirmedInput.type = 'password';
      toggleShowConfirmedPasswordButton.classList.add('tw-hidden');
      toggleHideConfirmedPasswordButton.classList.remove('tw-hidden');
    }
  });
});
//  strength password function 
var code = document.getElementById('RegisterForm-password');
var pswTxt = document.getElementById('pswStrengthTxt');

var strengthbar = document.getElementById('meter');

code.addEventListener('keyup', function () {
  code.addEventListener('keyup', function () {
    if (code.value.trim() === '') {
      pswTxt.textContent = '';
      strengthbar.value = 0;
    } else {
      checkpassword(code.value);
    }
  });
});
//var display = document.getElementsByClassName('textbox')[0];
function checkpassword(password) {
  var strength = 0;
  if (password.length >= 8) {
    strength += 1;
  }
  if (password.match(/[a-z]+/)) {
    strength += 1;
  }
  if (password.match(/[A-Z]+/)) {
    strength += 1;
  }
  if (password.match(/[0-9]+/)) {
    strength += 1;
  }
  if (password.match(/[$@#&!?]+/)) {
    strength += 1;
  }
  switch (strength) {
    case 0:
      strengthbar.value = 0;
      break;

    case 1:
      strengthbar.value = 25;
      isWeak();
      pswTxt.innerHTML = strengthMessages.weak;
      break;

    case 2:
      strengthbar.value = 50;
      isWeak();
      pswTxt.innerHTML = strengthMessages.medium;
      break;

    case 3:
      strengthbar.value = 75;
      isStrong();
      pswTxt.innerHTML = strengthMessages.strong;
      break;

    case 4:
      strengthbar.value = 100;
      pswTxt.innerHTML = strengthMessages.veryStrong;
      break;
  }
}

function isWeak() {
  strengthbar.classList.remove('tw-progress-value-green');
  strengthbar.classList.add('tw-progress-value-pale-salmon');
  pswTxt.style.color="#ffacac";
}
function isStrong() {
  strengthbar.classList.add('tw-progress-value-green');
  strengthbar.classList.remove('tw-progress-value-pale-salmon');
  pswTxt.style.color="#008001";
}